import { requestJson } from '@/ui/services/api.ts';
import { NpcPublicDTO, NpcPublicSchema } from '@hexcrawl/shared-utils';
import { z } from 'zod';

export const npcService = {
  listNpcs(playerCharacterId: string): Promise<NpcPublicDTO[]> {
    return requestJson<NpcPublicDTO[]>({
      url: `/npc?playerCharacterId=${encodeURIComponent(playerCharacterId)}`,
      method: 'GET',
      schema: z.array(NpcPublicSchema),
    });
  },

  getNpcById(npcId: string): Promise<NpcPublicDTO> {
    return requestJson<NpcPublicDTO>({
      url: `/npc/by-id?npcId=${encodeURIComponent(npcId)}`,
      method: 'GET',
      schema: NpcPublicSchema,
    });
  },

  createNpc(body: {
    name: string;
    playerCharacterId: string;
    spriteType?: 'composite' | 'static';
    sprite?: string;
  }): Promise<NpcPublicDTO> {
    return requestJson<NpcPublicDTO>({
      url: '/npc',
      method: 'POST',
      data: body,
      schema: NpcPublicSchema,
    });
  },

  patchNpc(npcId: string, patch: {
    motivations?: string[];
    playerExposedDescription?: string;
  }): Promise<NpcPublicDTO> {
    return requestJson<NpcPublicDTO>({
      url: '/npc',
      method: 'PATCH',
      data: { npcId, ...patch },
      schema: NpcPublicSchema,
    });
  },
};
